import { Flex, Form, FormItemProps } from 'antd'
import React from 'react'
import { Indication } from './Indication'

type Props = FormItemProps & {
  propsIndication?: { content: string }
}

export const FormItemWithIndications: React.FC<Props> = ({
  children,
  label,
  propsIndication,
  ...props
}) => {
  const hasLabel = propsIndication || label

  const labelBuilt = hasLabel ? (
    <>
      <Flex vertical>
        {label}
        {propsIndication && <Indication {...propsIndication} />}
      </Flex>
    </>
  ) : undefined

  return (
    <Form.Item label={labelBuilt} {...props}>
      {children}
    </Form.Item>
  )
}
